/* eslint-disable no-unused-vars */
/* eslint-disable guard-for-in, no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-await-in-loop */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import RandExp from 'randexp';
import * as Sentry from '@sentry/react';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'utils/moment';
import SectionHeader from '../../../components/sectionHeader';
import HeaderBack from '../../../components/headerBack';
import Button from '../../../components/button';
import CustomFields from '../../../components/customFields/CustomFields';
import Modal from '../../../components/modal';
import {
  fetchPublishedForm,
  createFormAnswer,
  getPortalFormSchema,
  actionSaveTabView
} from '../redux/actions';
import closeIcon from '../../../icons/closeIcon.svg';
import TagComponent from '../../../components/tags';
import styles from './form_complete.module.scss';
import { MYFORMS } from '../../../constants/RouterConstants';
import { S3Uploads, GetFileName } from '../../services';
import Clickable from '../../../components/clickable/Clickable';
import {
  DATE_SUBMIT_FIELD_TYPES,
  importAllImages,
  normalizeSubmittedDateValue
} from '../../../utils/helpers';
import Loading from '../../../components/loading';
import FormSubmitted from '../components/FormSubmitted';
import { getFieldError, getPhoneConvert, handleMultiFieldErrorList, getHasMapLocation } from '../utils/helpers';
import CollapsibleSections from '../../../components/customFields/CollapsibleSections';

const handleMultiGridSpecificFieldError = (field, formValues, handleSectionErrorMultiLevelField, handleMultiColumnGLS, form_data) => {
  let errorData = [];
  let isConditionallyVisible = true;
  if (field.conditional_field) {
    const conditionValues = field?.conditional_values;
    let fieldValue = form_data[field.conditional_field?.key];
    if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
    if (typeof fieldValue === 'object' && fieldValue?.level_0) {
      isConditionallyVisible = Object.values(fieldValue)?.filter(value => value !== '')?.join()
        === Object.values(conditionValues[0])?.filter(value => value !== '')?.join();
    } else {
      isConditionallyVisible = conditionValues.some(value => fieldValue?.includes(value?.value));
    }
  }
  Object.entries(field.multiple_fields).forEach(([key, config]) => {
    if (isConditionallyVisible) {
      const isMandatory = config.mandatory_multi_field;
      const fieldType = config?.type?.key;
      const value = formValues[key];
      const isMultiLevel = fieldType === 'multi_level';

      const isEmpty = value === null
        || value === undefined
        || value === ''
        || (Array.isArray(value) && value.length === 0);
      const field_type = fieldType === 'string' ? config?.validator : config?.inputType;
      const max_min = field_type || {};
      let errorMinMax = false;
      if (max_min?.type === 'min_max') {
        const length = value?.length ?? 0;
        const min = max_min?.minValue && +max_min?.minValue;
        const max = max_min?.maxValue && +max_min?.maxValue;

        if (min && length < min) {
          errorMinMax = true;
        } else if (max && length > max) {
          errorMinMax = true;
        }
      }
      if (isMultiLevel) {
        if ((isEmpty || handleSectionErrorMultiLevelField(config, value)) && isMandatory) {
          errorData.push(config.title);
        }
      } else if (fieldType === 'string' && config?.text_aera) {
        const showValidationLimit = value?.length > config.validation_limit;

        // text area validation implementation

        if (isMandatory) {
          if (isEmpty || showValidationLimit) {
            errorData.push(config.title);
          }
        } else if (!isEmpty && showValidationLimit) {
          errorData.push(config.title);
        }
      } else if (isMandatory && isEmpty) {
        errorData.push(config.title);
      } else if (isMandatory && config?.type?.key === 'dataSource-ds8') {
        const showError = handleMultiColumnGLS(key, config, value);
        if (showError) {
          errorData.push(config.title);
        }
      } else if (['string', 'number'].includes(fieldType) && !isEmpty && errorMinMax) {
        errorData.push(config.title);
      }
    }
  });
  return errorData;
};

class CompleteForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFormErrors: false,
      answers: {
        form_date: moment().format(),
        tags: []
      },
      apiStatusError: undefined,
      loadingStatus: false,
      fieldErrors: {},
      errorsList: {},
      formActiveIndex: 0,
      groupedSections: [],
      formTabFeilds: [],
      opsLogTags: [],
      isDraft: false,
      ssi_data: false,
      apiStatus: false,
      errorListMCG: {},
      customErrors: [],
      fieldErrorsList: [],
      errorModal: false,
      warningErrors: [],
      warningModal: false,
      alert: false
    };
    this.images = importAllImages(
      require.context(
        '../../../icons/inspection-icons',
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
    this.URL = MYFORMS;
    if (props?.match?.url?.includes('arff')) {
      this.URL = '/arff/forms';
    }
  }

  componentDidMount() {
    const {
      actionFetch,
      match,
      flowFormId,
      actionFetchFormSchema
    } = this.props;
    const id = match?.params?.id || flowFormId;
    this.setState({
      loadingStatus: true
    });
    actionFetch(id);
    actionFetchFormSchema(id);
  }

  static getDerivedStateFromProps(props, state) {
    // grab user from state

    let ssi_data = false;
    const temp = { ...state.answers };
    if (props.user.id) {
      const havingRole = props.user?.roles?.filter(
        e => e?.meta_data?.ssi_data === true || e.name === 'System Admin'
      );
      if (havingRole?.length > 0) ssi_data = true;
    }
    if (!state.requiredMap && props.form && props.form.id) {
      const {
        form: { schema }
      } = props.form;
      let requiredMap = {};
      let fieldErrors = {};
      let placeHolders = {};
      let errorListMCG = {};
      const conditionalFields = {};
      const attachmentFields = [];
      const signatureFields = [];
      const sections = [];
      let currentSection = null;
      const firstGroup = [];
      const schemaFields = schema?.fields?.length > 0
                  && schema?.fields?.filter(each => !each.disable_for_portal && each.type !== 'ssi_field') || [];
      if (schemaFields?.length > 0) {
        schemaFields.forEach((detailField) => {
          const dafultValues = detailField?.settings?.multiFields_default_values || {};
          const fixedRowFiledsCheck = detailField?.type==='multi_field' && detailField?.fixed_Rows && detailField?.repeat_field
          && Object.keys(dafultValues)?.length>0;
          const data = Object.values(dafultValues);
          if (detailField.type === 'boolean') {
            temp[detailField.id] = false;
          }
          if (detailField.type === 'header' && detailField?.settings?.showTab) {
            currentSection = {
              header: detailField.title,
              items: []
            };
            sections.push(currentSection);
          } else if (currentSection) {
            currentSection.items.push(detailField);
          } else {
            firstGroup.push(detailField);
          }
          if (fixedRowFiledsCheck && data) {
            temp[detailField?.id] = data;
            errorListMCG = handleMultiFieldErrorList(detailField, data, detailField.id, {});
            let error = false;
            const multiFieldsErrors = {};
            if (detailField?.required && detailField?.multiple_fields) {
              const multipleFieldsKeys = Object.keys(detailField?.multiple_fields);
              Object.keys(dafultValues).forEach((eachRow) => {
                error = multipleFieldsKeys.some(eachSubField => !(multipleFieldsKeys.includes(eachSubField)
                        && (dafultValues?.[eachRow]?.[eachSubField] && `${dafultValues?.[eachRow]?.[eachSubField]}`.length>0)));
                multiFieldsErrors[eachRow] = error;
              });
            }
            error = multiFieldsErrors && Object.keys(multiFieldsErrors).some(
              k => multiFieldsErrors?.[k] === true
            );

            fieldErrors = {
              ...fieldErrors,
              [detailField.id]: error
            };
          }
          if (detailField.type !== 'header' && !fixedRowFiledsCheck) {
            requiredMap = {
              ...requiredMap,
              [detailField.id]: detailField.type === 'signature' ? false : detailField.required
            };
            if (!detailField.conditional) {
              fieldErrors = {
                ...fieldErrors,
                [detailField.id]: !ssi_data && (detailField.type === 'ssi_field' || detailField.type === 'signature') ? false : detailField.required
              };
              if (sections?.length > 0) {
                sections[sections.length - 1].fieldErrors = sections[sections.length - 1].items.some(e => e.required === true);
              }
            } else if ((detailField.hide_for_all_users === false
              || Object.keys(detailField).includes('hide_for_all_users') === false) && conditionalFields[detailField?.conditional_field?.key]) {
              conditionalFields[
                detailField?.conditional_field?.key
              ] = [...conditionalFields[detailField?.conditional_field?.key], detailField];
            } else if (detailField.hide_for_all_users === false || Object.keys(detailField).includes('hide_for_all_users') === false) {
              if ((detailField?.conditional && detailField.conditional_field?.type === 'boolean'
                && detailField.conditional_values?.some(i => i.value === 'false')
              )) {
                fieldErrors = {
                  ...fieldErrors,
                  [detailField.id]: detailField.required
                };
              }
              conditionalFields[
                detailField?.conditional_field?.key
              ] = [detailField];
            }
          } else if (detailField.type === 'header' && detailField?.conditional
            && detailField?.conditional_values && detailField?.conditional_values?.length > 0) {
            if (detailField?.conditional && detailField?.conditional_values && detailField?.conditional_values?.length > 0) {
              if (conditionalFields[detailField?.conditional_field?.key]) {
                conditionalFields[
                  detailField?.conditional_field?.key
                ] = [...conditionalFields[detailField?.conditional_field?.key], detailField];
              } else {
                conditionalFields[
                  detailField?.conditional_field?.key
                ] = [detailField];
              }
            }
          }
          if (detailField.type === 'attachments') attachmentFields.push(detailField.id);
          if (detailField.type === 'signature') signatureFields.push(detailField.id);
          if (detailField?.validators?.length > 0 && detailField.validators[0]?.type === 'Regex' && detailField.validators[0]?.value) {
            let randexp = new RandExp(detailField.validators[0]?.value).gen();
            if (detailField.validators[0]?.label === 'Email') {
              randexp = 'name@email.com';
            }
            placeHolders = {
              ...placeHolders,
              [detailField.id]: randexp
            };
          }
        });
      }
      if (schemaFields && schemaFields?.length > 0) {
        schemaFields.forEach((item) => {
          if (item?.type === 'string' && item?.default_text && item?.id) {
            temp[item.id] = item?.default_text;
            fieldErrors = { ...fieldErrors, [item.id]: false };
          }
          if (item.type==='dataSource' && item.dataSourceID==='ds13') {
            temp[item.id] = ' ';
            fieldErrors = { ...fieldErrors, [item.id]: false };
          }
        });
      }
      if (firstGroup?.length > 0 && sections?.length > 0) {
        const firstIndexItems = sections?.map(e => e.items)[0];
        firstIndexItems.unshift(...firstGroup);
        sections[0].items = firstIndexItems;
      }
      const firstGroupedItems = sections?.map(e => e.items)[0] || [];
      return {
        ...state,
        requiredMap,
        fieldErrors,
        attachmentFields,
        conditionalFields,
        signatureFields,
        placeHolders,
        errorListMCG,
        groupedSections: sections,
        formTabFeilds: firstGroupedItems?.length > 0 ? firstGroupedItems : schemaFields,
        ssi_data,
        answers: temp
      };
    }
    if (props.user.id && !state.answers.created_by) {
      return {
        ...state,
        answers: {
          ...state.answers,
          created_by: {
            id: props.user.id,
            fullname: props.user.fullname
          }
        }
      };
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    const { dataSourceAction, dataSourceValues, createAction, getFormSchemaAction, createdFormAnswer, form, history, opslog_tags } = this.props;
    const { groupedSections, loadingStatus, opsLogTags, answers, isDraft } = this.state;
    if (opslog_tags && opsLogTags?.length===0 && answers?.tags?.length===0
      && !(answers?.tags?.length === opslog_tags?.filter(e => !e?.status)?.length)) {
      this.updateTags(opslog_tags?.filter(e => !e?.status), answers?.tags||[]);
    }
    if (prevProps?.createAction?.loading === true && createAction?.success === true && loadingStatus) {
      if (form?.settings?.approvals && !isDraft) {
        history.push(`${this.URL}/${createdFormAnswer?.key}/detail`);
      }
      this.setState({
        loadingStatus: false,
        apiStatus: createAction?.success
      });
      this.handleTabClick(0);
    }
    if (createAction?.error === true && loadingStatus) {
      this.setState({
        apiStatusError: createAction.error,
        loadingStatus: false
      });
    }
    if (prevProps?.createAction?.loading === true
      && createAction?.loading === false
      && loadingStatus) {
      const nextState = { loadingStatus: false };
      if (createAction?.success === true) {
        nextState.apiStatus = createAction?.success;
      } else if (createAction?.error === true) {
        nextState.apiStatusError = createAction.error;
      }
      this.setState(nextState);
    }
    if (prevProps?.getFormSchemaAction?.loading === true
       && getFormSchemaAction?.loading === false && loadingStatus) {
      this.setState({
        loadingStatus: false
      });
    }
    if (dataSourceValues && typeof dataSourceValues === 'object'
     && Object.keys(dataSourceValues)?.length > 0 && groupedSections?.length>0
      && prevProps.dataSourceAction?.loading === true && dataSourceAction?.loading === false) {
      let values = '';
      groupedSections.forEach((val) => {
        val.items.some((item) => {
          if (dataSourceValues[item.id] && item.type === 'dataSourceMultiLevel') {
              values = dataSourceValues[item.id].find(v => v?.name === item?.global_location?.name)?.location_levels;
              return true;
          }
          return false;
        });
      });
      this.setState({ sourceValues: values });
    }
  }

  componentWillUnmount() {
    const { acitonGetTabView } = this.props;
    acitonGetTabView();
  }

  // eslint-disable-next-line react/sort-comp
  goBackToForms = () => {
    const {
      history,
      flowFieldId,
      handleFlowField
    } = this.props;
    if (flowFieldId) {
      handleFlowField('', flowFieldId);
    } else {
      history.push(`${this.URL}`);
    }
  };

  handleEntry = () => {
    this.setState({ answers: { form_date: moment().format(), tags: [] } });
  }

  copyFieldData = (fields, fieldId, answer, answers, currentField) => {
    fields.forEach((field) => {
      const conditional = fieldId === field?.settings?.conditionalCopyField && currentField?.type === 'select'
      ? field?.settings?.conditionalCopyValues?.some(i => i?.value === answer) : answer === true;
      const withoutCondition = !field?.settings?.conditionalCopyField || field?.settings?.conditionalCopyField === '';
      if (conditional || withoutCondition) {
        const ans = (conditional && answers[field?.settings?.selectedCopyField]) || (withoutCondition && answer);
        this.handleFieldErrorChanged(field.id, !ans);
        this.setState(prevState => ({
            answers: {
              ...prevState.answers,
              [field.id]: ans || ''
            }
          }));
        }
      });
  };

  resolveConcatValue = (field, answers, orderedFields) => {
  if (
    !field?.settings?.concatFields
    || !Array.isArray(field?.settings?.selectedContextualField)
    || !Array.isArray(orderedFields)
  ) {
    return null;
  }

  const selectedMap = {};
  field.settings.selectedContextualField.forEach((sf) => {
    selectedMap[sf.value] = sf;
  });

  const result = [];

  orderedFields.forEach((stateField) => {
    const selected = selectedMap[stateField.id];
    if (!selected) return;

    const val = answers?.[stateField.id];
    let output = '';

    if (val !== undefined && val !== null) {
      switch (selected?.type) {
        case 'address':
          output = typeof val === 'object'
            ? Object.values(val).filter(Boolean).join(' ')
            : String(val)
              .replace(/[^a-zA-Z0-9\s]/g, '')
              .replace(/\s+/g, ' ')
              .trim();
          break;

        case 'date':
        case 'datetime':
          output = new Date(val).toLocaleDateString();
          break;

        default:
          output = String(val);
      }
    }
    result.push(output);
  });

  return result.join(' ').replace(/\s+/g, ' ').trim();
};

applyConcatFields = (fields, answers, orderedFields) => {
  const updatedAnswers = { ...answers };

  fields.forEach((field) => {
    if (!field?.settings?.concatFields) return;

    const value = this.resolveConcatValue(field, updatedAnswers, orderedFields);
    if (value !== null) {
      updatedAnswers[field.id] = value;
    }
  });

  return updatedAnswers;
};


  handleAnswerChanged = (answer, fieldId, section, multiField) => {
    const { conditionalFields, placeHolders, groupedSections, requiredMap,
      formTabFeilds, errorsList, answers } = this.state;
    const { form, intl } = this.props;
    const fields = form?.form?.schema?.fields || [];
    const copyField = formTabFeilds.filter(i => i?.settings?.copyField
      && (i?.settings?.selectedCopyField === fieldId || i?.settings?.conditionalCopyField === fieldId));
      if (copyField?.length > 0) {
        this.copyFieldData(copyField, fieldId, answer, answers, formTabFeilds?.find(i => i.id === fieldId));
      }
    if (conditionalFields?.[fieldId]) {
      let tempGroupedSections = [];
      conditionalFields[fieldId].forEach((item) => {
        const conditionValues = item?.conditional_values;
        let fieldValue = answer;
        let enabelCondition = false;
        if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
        if (typeof fieldValue === 'object' && fieldValue?.level_0) {
          enabelCondition = Object.values(fieldValue)?.filter(value => value !== '')?.join()
            === Object.values(conditionValues[0])?.filter(value => value !== '')?.join();
        } else if (fieldValue && (item?.conditional_field?.type === 'duration' || item?.conditional_field?.type === 'number')) {
          if (item?.conditional_field?.type === 'number' && fieldValue) {
            fieldValue = +fieldValue;
          }
          enabelCondition = this.handleDurationCondition(fieldValue, conditionValues);
        } else {
          enabelCondition = conditionValues.some(value => (Array.isArray(fieldValue) ? fieldValue.indexOf(value?.value) !== -1
            : fieldValue === value?.value));
        }
        if (item?.type === 'header') {
          tempGroupedSections = (tempGroupedSections?.length > 0 ? tempGroupedSections : groupedSections)?.map((ele) => {
            if ((ele?.id === item?.id) && item?.settings?.showTab) {
              if (enabelCondition) {
                return { ...ele, visibility: true };
              }
              return { ...ele, visibility: false };
            }
            return ele;
          });
        } else {
          tempGroupedSections = tempGroupedSections?.length > 0 ? tempGroupedSections : groupedSections;
        }
        if (item.required) {
          this.handleFieldErrorChanged(
            item.id,
            enabelCondition ? !answers?.[item?.id] : false
          );
        }
        if (item?.type !== 'header') {
          if (enabelCondition) {
            this.setState(prevState => ({
              answers: {
                ...prevState.answers,
                [fieldId]: answer,
                [item.id]: prevState?.answers?.[item.id] || (item?.type === 'boolean' ? false : '')
              }
            }));
          } else {
            this.setState(prevState => ({
              answers: {
                ...prevState.answers,
                [fieldId]: answer,
                [item.id]: item?.type === 'boolean' ? false : ''
              }
            }));
            if (item?.conditional) this.handleAnswerChanged('', item.id);
          }
        }
        if (tempGroupedSections.length > 0) {
          const findIndex = this.indexOfSectionHeader(tempGroupedSections, fieldId);
          const sectionErrors = this.handleSectionErrorChanged(fieldId, answer, requiredMap, errorsList, formTabFeilds);
          tempGroupedSections[findIndex].fieldErrors = sectionErrors;
        }
      });
      this.setState(prevState => ({
        answers: {
          ...prevState.answers,
          [fieldId]: answer
        },
        groupedSections: tempGroupedSections
      }));
    } else if (fieldId === 'tags') {
      const { opsLogTags } = this.state;
      const updatedOpsLogTags = opsLogTags?.filter(e => e?.id!==answer?.id);
      this.setState(prev => ({
        opsLogTags: updatedOpsLogTags,
        answers: {
          ...prev?.answers,
          [fieldId]: [...prev?.answers?.tags, answer]
        }
      }));
    } else if (fieldId==='global_location') {
      this.setState(prev => ({
        answers: {
          ...prev?.answers,
          [section]: { ...prev?.answers[section], ...answer }
        }
      }));
    } else if (fieldId ==='location_attachment'|| fieldId ==='location_marked' || fieldId === 'selected_map') {
      this.setState(prev => ({
        answers: {
          ...prev?.answers,
          [section]: { ...prev?.answers[section], [fieldId]: answer }
        }
      }));
    } else if (fieldId ==='location') {
      this.setState(prev => ({
        answers: {
          ...prev?.answers,
          [section]: { ...prev?.answers[section], map_location: answer }
        }
      }));
    } else {
      let headerValidate = true;
      const fieldType = fields?.find(obj => obj.id === fieldId);
      if (fieldType?.type === 'string' && fieldType.validators?.length > 0
        && (fieldType.validators[0]?.value || fieldType.validators[0]?.type === 'min_max')) {
        if (fieldType.validators[0]?.type === 'Regex') {
          let convertValidtorValueToRegex = fieldType.validators[0].value;
          if (fieldType.validators[0]?.label === 'Custom Validation') {
            if (convertValidtorValueToRegex.endsWith('-')) {
              convertValidtorValueToRegex = fieldType.validators[0].value.slice(0, -1);
            }
            convertValidtorValueToRegex = `^${convertValidtorValueToRegex}$`;
          }

          let phoneValConvert = '';
          if (fieldType.validators[0]?.label === 'Phone Number') {
            ({ phoneValConvert, convertValidtorValueToRegex } = getPhoneConvert(answer));
          }

          const validateRegex = (val) => {
            if (fieldType?.validators[0]?.multiple_email && answer?.length) {
              const invalidEmails = answer
                ?.split(',')
                ?.filter((e) => {
                  if (typeof e !== 'string') return false;
                  const trimmedEmail = e?.trim();
                  return trimmedEmail && !regexValue?.test(trimmedEmail);
                });
              this.invalidEmailCount = invalidEmails?.length;
              this.invalidEmails = invalidEmails;
              return invalidEmails.length > 0;
              }
            return !regexValue.test(val);
          };
          const regexValue = new RegExp(convertValidtorValueToRegex);
          if (answer && validateRegex(phoneValConvert || answer)) {
            if (groupedSections?.length > 0) {
              const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
              groupedSections[findIndex].fieldErrors = true;
              headerValidate = false;
            }
            this.setState((prevState) => {
              const fieldError = getFieldError(fieldType.validators[0]?.label, fieldId, placeHolders, this.invalidEmailCount,
                fieldType.validators[0]?.multiple_email);
              return {
                errorsList: {
                  ...prevState.errorsList,
                  [fieldId]: fieldError
                },
                groupedSections
              };
            });
          } else {
            if (groupedSections?.length > 0) {
              const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
              groupedSections[findIndex].fieldErrors = false;
              headerValidate = true;
            }
            this.setState(prevState => ({
              errorsList: {
                ...prevState.errorsList,
                [fieldId]: ''
              },
              groupedSections
            }));
          }
        } else if (fieldType.validators?.length > 0 && fieldType.validators[0]?.type === 'maxLength') {
          if (fieldType.validators[0]?.value < answer.length) {
            if (groupedSections?.length > 0) {
              const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
              groupedSections[findIndex].fieldErrors = true;
              headerValidate = false;
            }
            const fieldError = `Character limit exceeded. Max ${fieldType.validators[0]?.value} characters.`;
            this.setState(prevState => ({
              errorsList: {
                ...prevState.errorsList,
                [fieldId]: fieldError
              },
              groupedSections
            }));
          } else {
            if (groupedSections?.length > 0) {
              const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
              groupedSections[findIndex].fieldErrors = false;
              headerValidate = true;
            }
            this.setState(prevState => ({
              errorsList: {
                ...prevState.errorsList,
                [fieldId]: ''
              },
              groupedSections,
              fieldErrorsList: [],
              warningErrors: []
            }));
          }
        } else if (fieldType.validators?.length > 0 && fieldType.validators[0]?.type === 'min_max') {
    const { minValue, maxValue } = fieldType.validators[0];
    const { length } = answer;
    const min = minValue && (+minValue ?? null);
    const max = maxValue && (+maxValue ?? null);
      const errorsListData = {};
    if (!fieldType.required && ((min && length < min) || (max && length > max))) {
      if (min && length < min) {
       errorsListData[fieldType.id] = intl.formatMessage({ id: 'pulpoforms.errors.limit.minlength' }, { count: min });
      } else if (max && length > max) {
       errorsListData[fieldType.id] = intl.formatMessage({ id: 'pulpoforms.errors.limit.maxlength' }, { count: max });
      }
    } else if (!fieldType.required) {
      errorsListData[fieldType.id] = '';
    }
    this.setState(prevState => ({
              errorsList: {
                ...prevState.errorsList,
                ...errorsListData
              },
              [fieldId]: answer
            }));
  }
      }

      if (groupedSections.length > 0 && headerValidate) {
        const findIndex = this.indexOfSectionHeader(groupedSections, fieldId);
        const sectionErrors = this.handleSectionErrorChanged(fieldId, answer, requiredMap, errorsList, formTabFeilds);
        if (groupedSections?.[findIndex]?.fieldErrors) {
          groupedSections[findIndex].fieldErrors = sectionErrors || false;
        }
      }
      if (fieldType?.type === 'multi_field' && answer?.length > 0) {
        this.setState((prevState) => {
          const updatedErrorListMCG=handleMultiFieldErrorList(fieldType, answer, fieldId, prevState);
          return { errorListMCG: updatedErrorListMCG };
        });
      }
      if (fieldType?.type === 'multi_field' && answer?.length > 0 && multiField?.multiFieldType === 'duration') {
        this.setState((prev) => {
          const prevAnswers = prev.answers || {};
          const prevFieldAnswer = Array.isArray(prevAnswers[fieldId]) ? prevAnswers[fieldId][0] || {} : {};
          const incomingAnswer = answer[0] || {};
          const newMergedAnswer = {
            ...prevFieldAnswer,
            ...incomingAnswer
          };
          return {
            answers: {
              ...prevAnswers,
              [fieldId]: [newMergedAnswer]
            }
          };
        });
      } else {
        this.setState(
          (prevState) => {
            const updatedAnswers = {
              ...prevState.answers,
              [fieldId]: answer
            };
            const concatFields = fields.filter(f => f?.settings?.concatFields);
            concatFields.forEach((concatField) => {
              const concatValue = this.resolveConcatValue(concatField, updatedAnswers,
                formTabFeilds);
              if (concatValue !== null) {
                updatedAnswers[concatField.id] = concatValue;
                this.handleFieldErrorChanged(concatField.id, false);
              } else {
                this.handleFieldErrorChanged(concatField.id, true);
              }
            });

            return {
              answers: updatedAnswers,
              customMessage: '',
              groupedSections
            };
          }
        );
      }
    }

    // USED TO PERFORM CUSTOM JS LOGIC WHILE USER INPUTS SOMETHING INTO FIELD
    const beforeSubmitProcess = form?.form?.trigger_config?.pre_custom_process;
    const checkInvolvedIds = form?.form?.trigger_config?.involvedIds;
    if (beforeSubmitProcess && checkInvolvedIds?.length && checkInvolvedIds?.includes(fieldId)) {
      try {
        const form_data = { ...answers, [fieldId]: answer };
        if (beforeSubmitProcess) {
          const additionalProps = this.props; const additionalStates = this.state;
          // eslint-disable-next-line no-eval
          eval(beforeSubmitProcess);
          if (form_data) {
            this.setState(prev => ({
              answers: {
                ...form_data,
                [fieldId]: answer,
                customJSDateShow: true
              }
            }), () => {
              if (form_data && Object.keys(form_data || {})?.length > 0) {
                Object.keys(form_data).forEach(formField => (
                  this.handleFieldErrorChanged(formField, !form_data?.[formField])
                ));
              }
            });
          }
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  };

  handleSectionErrorMultiField = (v, answer={}) => {
    let level_1 = ''; let level_2 = '';
    let levelRes = true;
    let values = {};
   const { sourceValues } = this.state;
   let ans_level_0 = 'level_0'; let ans_level_1 = 'level_1'; let ans_level_2 = 'level_2';
   if (v.type === 'multi_level') {
     values = v?.values;
   } else {
     values = sourceValues;
     ans_level_0 = 'level_1'; ans_level_1 = 'level_2'; ans_level_2 = 'level_3';
   }

   if (answer[ans_level_0]) {
     for (let v1 in values) {
       if (values[v1].title === answer[ans_level_0]) {
         level_1 = values[v1]?.level_1 || '';
         levelRes = false;
       }
       if (level_1) {
         for (let v2 in level_1) {
           if (level_1[v2].title === answer[ans_level_1]) {
             level_2 = level_1[v2].level_2 || '';
             levelRes = false;
             break;
           } else {
             levelRes = true;
           }
         }
         if (level_2) {
           for (let v3 in level_2) {
             if (level_2[v3].title === answer[ans_level_2]) {
               levelRes = false;
               break;
             } else {
               levelRes = true;
             }
           }
         }
       }
     }
   }
    return levelRes;
  }

  handleSectionErrorChanged = (fieldId, answer, requiredMap, errorsList, formTabFeilds) => {
    const { answers } = this.state;
   const sectionErrors = formTabFeilds.some((v) => {
     if (!v?.type?.toLowerCase()?.includes('multi')) {
       if (v.id === fieldId && v?.required && (!answer || answer?.length === 0)) {
         return true;
       }
       if (v.id === fieldId && !v?.required && (!answer || answer?.length === 0)) {
         return false;
       }
       if (v.id !== fieldId) {
         if (errorsList[v.id]) {
           return errorsList[v.id];
         }
         return requiredMap[v.id] && !answers[v.id]?.length>0;
       }
     } else if (v?.type === 'dataSourceMultiLevel' || v?.type === 'multi_level') {
       if (v.id === fieldId && requiredMap[v.id]) {
          return this.handleSectionErrorMultiField(v, answer);
       } if (v.id !== fieldId && requiredMap[v.id]) {
           return this.handleSectionErrorMultiField(v, answers[v.id]);
       }
     }
     return false;
   });
   return sectionErrors;
  }

  handleFieldErrorChanged = (fieldId, errorValue) => {
    this.setState(prevState => ({
      ...prevState,
      fieldErrors: {
        ...prevState.fieldErrors,
        [fieldId]: errorValue
      }
    }));
  };

  handleSearchForUser = () => {
    // const { actionSearchUser } = this.props;

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      // actionSearchUser(value);
    }, 300);
  };

  handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id && e.name) {
        oldAttachments.push(e.name);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await GetFileName.getPermitUploadFileName(newAttachments?.length);
      if (!fileIds) {
        return null; // this stops submit flow
      }
    }
    if (fileIds) {
      await S3Uploads.uploadFiles(
        newAttachments,
        fileIds.filename,
        entity || 'myForms',
        this.getErrorAlert
      ).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }

    // Add old attachments
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }

    return attachmentIds;
  };

  getFileNames = async (count) => {
    const response = await GetFileName.getPermitUploadFileName(count);
    return response;
  };

  uploadtoS3 = async (attachments) => {
    let fileIds = '';
    fileIds = await this.getFileNames(attachments.length);
    const list = [];
    if (fileIds) {
      await this.doS3Upload(attachments, fileIds, 'myForms', this.getErrorAlert)
        .then((res) => {
          res.forEach((ele) => {
            list.push(ele?.id?.toString());
          });
        });
    }
    return list;
  };

  getErrorAlert = (value) => {
    this.setState({ alert: value });
  }

  checkValidTags = (data) => {
    if (data !== undefined && data.length > 0) {
      const validatedTags = [];
      data.forEach((tag) => {
        const tagsArray = [];
        if (typeof tag === 'string') {
          tagsArray.push(tag);
        } else {
          tag.forEach((t) => {
            if (typeof t === 'string') {
              tagsArray.push(t);
            }
          });
        }
        if (tagsArray.length > 0) {
          validatedTags.push(tagsArray);
        }
      });
      return validatedTags;
    }
    return [];
  };

  checkAllChecklistsSelected =(fieldId) => {
    const { answers, formTabFeilds } = this.state;
    const isRequired = formTabFeilds?.filter(each => each.id===fieldId)?.[0]?.required || false;
    let flag = false;
    if (isRequired && answers[fieldId]) {
      const answered = Object.keys(answers[fieldId]).filter(field => field!=='version');
      let questions = formTabFeilds?.filter(each => each.id===fieldId)?.[0]?.schema?.fields || [];
      questions = questions?.filter(each => each.type==='inspection');
      if (answered.length === questions.length) {
        flag=answered.every((each) => {
          const qtnsChecklists = questions.filter(e => e.id=== each)?.[0]?.checklist?.length;
          if (Object.keys(answers[fieldId][each]).length === qtnsChecklists) {
            return true;
          }
          return false;
        });
      }
    }
    if (flag || !isRequired) {
      this.handleFieldErrorChanged(fieldId, false);
      this.setState({ showFormErrors: false });
    }
  }

  handleCheckListAnswer = (fieldId, checkLisId, subCheckListKey, pass, remarks) => {
    const { answers, formTabFeilds } = this.state;
    const version= formTabFeilds?.length > 0 && formTabFeilds.find(field => field.id===fieldId)?.version;
    const useCheckObj = {
      [fieldId]: {
        ...answers?.[fieldId],
        version,
        [checkLisId]: {
          ...answers?.[fieldId]?.[checkLisId],
          [subCheckListKey]: {
            ...answers?.[fieldId]?.[checkLisId]?.[subCheckListKey],
            check_lilst_status: pass,
            checklist_remarks_list: remarks
          }
        }
      }
    };
    this.setState(prevState => ({
      answers: {
        ...prevState.answers,
        ...useCheckObj
      }
    }), () => this.checkAllChecklistsSelected(fieldId));
  }

  handleWarning = (data) => {
    if (data) {
      this.setState({ answers: data, warningModal: true });
    } else {
      this.setState({ warningModal: true });
    }
  }

  handleValidations = async (isDraft) => {
      const {
        fieldErrors,
        answers: { form_date, created_by, ...form_data },
        errorsList,
        groupedSections, errorListMCG
      } = this.state;
      const {
        form,
        uniqueFields,
        intl
      } = this.props;
      let fieldErrorsData = { ...fieldErrors };
      let errorsListData = { ...errorsList };
      let errorListMCGData = { ...errorListMCG };
      if (!isDraft && Object.values(errorsListData)?.some(i => i)) {
        this.setState({ showFormErrors: true });
        return;
      }
      if (groupedSections?.length > 0) {
        let invisibleSections = [];
        invisibleSections = groupedSections?.filter(item => !item?.visibility);
        if (invisibleSections?.length > 0) {
          invisibleSections.forEach((section) => {
            if (section.items.length>0) {
              section.items.forEach((item) => {
              errorsListData[item.id]='';
              if (item.required) {
                fieldErrorsData[item.id]=false;
                }
              if (errorListMCGData[item.id]) {
                delete errorListMCGData[item.id];
              }
              });
            }
          });
        }
      }
      const fieldTitles = {};
      if (form?.form?.schema?.fields) {
        form.form.schema.fields.forEach((field) => {
        if (field?.required === false) {
          fieldErrorsData[field?.id] = false;
        }
        if (field?.type === 'toggle') {
          fieldErrorsData[field?.id] = false;
        }
        fieldTitles[field?.id] = field?.title;
      });
      }
      let noErrors = isDraft || fieldErrorsData && Object.keys(fieldErrorsData).every(
        k => fieldErrorsData[k] === false
      );
      const errorsListValues = isDraft? []:Object.values(errorsList).filter(val => val!=='');
      const r = errorListMCGData && Object.keys(errorListMCGData).map(val => ({ [val]: errorListMCGData[val] }));
      const errorMCGlist = isDraft ? []: r;
      let customError = false;
      let customMessage = '';
      let customErrors = [];
      let warningErrors = [];
      let customValidation = form?.settings?.custom_validation;
      if (uniqueFields && Object.keys(uniqueFields)?.length > 0) {
        Object.keys(uniqueFields).forEach((uniqField) => {
          if (uniqueFields[uniqField]?.filter(val => val?.value === form_data?.[uniqField])?.length > 0) {
            customErrors.push(`${fieldTitles?.[uniqField]} already exists. Please enter a different ${fieldTitles?.[uniqField]}`);
            noErrors = false;
          }
        });
      }
      try {
        if (customValidation) {
          const fd = form_data;
          const dt = f => (typeof (f) === 'object' ? new Date(f.toISOString()) : new Date(f));
          // eslint-disable-next-line no-eval
          eval(customValidation);
        }
      } catch (error) {
        // nothing
        Sentry.captureException(error);
      }

     if (!isDraft && this.handleValidErrors(errorMCGlist, errorsList, fieldErrors, fieldTitles, customMessage, customErrors, fieldErrorsData)) {
      return;
     }
      let beforeSubmitProcess = form?.form?.trigger_config?.pre_custom_process;
      let warning = false;
      try {
        if (beforeSubmitProcess) {
          // eslint-disable-next-line no-eval
          eval(beforeSubmitProcess);
          if (warning) {
            this.handleWarning({ form_date, created_by, ...form_data });
          }
        }
      } catch (error) {
        Sentry.captureException(error);
      }
      if (noErrors && !customError && errorsListValues.length === 0 && errorMCGlist.length === 0) {
        this.setState({ answers: { form_date, created_by, ...form_data } }, () => this.handleSubmit(isDraft));
      } else {
        this.setState({ showFormErrors: true, customMessage, customErrors, warningErrors });
      }
    };

  handleSectionErrorMultiLevelField = (v, answer={}) => {
    let level_1 = ''; let level_2 = '';
    let levelRes = true;
    let values = v?.values;
    let ans_level_0 = 'level_0'; let ans_level_1 = 'level_1'; let ans_level_2 = 'level_2';

   if (answer[ans_level_0]) {
    // eslint-disable-next-line guard-for-in
    for (let v1 in values) {
      if (values[v1].title === answer[ans_level_0]) {
        level_1 = values[v1]?.level_1 || '';
        levelRes = false;
      }
      if (level_1) {
        for (let v2 in level_1) {
          if (level_1[v2].title === answer[ans_level_1]) {
            level_2 = level_1[v2].level_2 || '';
            levelRes = false;
            break;
          } else {
            levelRes = true;
          }
        }
        if (level_2) {
          for (let v3 in level_2) {
            if (level_2[v3].title === answer[ans_level_2]) {
              levelRes = false;
              break;
            } else {
              levelRes = true;
            }
          }
        }
      }
    }
    }
    return levelRes;
  }

  handleMultiColumnGLS = (fieldId, field, ans_values) => {
    const { dataSourceValues } = this.props;
    const specificFieldValues = dataSourceValues[fieldId];
    let finalError;
    for (const [key, value] of Object.entries(ans_values)) {
      if (key === 'level_0') {
        let levelZeroValues = specificFieldValues?.filter(
          levelZeroValue => (levelZeroValue?.name === value)
        );
        if (levelZeroValues?.length === 0) {
          finalError = field?.mandatory_multi_field || false;
        } else if (value !== '' && levelZeroValues?.length > 0) {
          let levelOneValues = levelZeroValues[0].location_levels;
          if (levelOneValues?.length === 0) {
            finalError = false;
          } else {
            finalError = field?.mandatory_multi_field || false;
          }
        }
      } else if (key === 'level_1') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && levelOneValues?.length > 0) {
          levelOneValues = levelOneValues.filter(
            val => val?.title === value
          );
          if (levelOneValues.length === 0) {
            finalError = field?.mandatory_multi_field || false;
          } else if (value !== '' && levelOneValues?.length > 0) {
            levelTwoValues = levelOneValues[0].level_1;
            if (levelTwoValues?.length === 0) {
              finalError = false;
            } else {
              finalError = field?.mandatory_multi_field || false;
            }
          }
        }
      } else if (key === 'level_2') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        let levelThreeValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && ans_values?.level_1 && levelOneValues?.length > 0) {
          levelTwoValues = levelOneValues.filter(
            val => (val?.title === ans_values?.level_1)
          );
          if (levelTwoValues.length === 0) {
            finalError = field?.mandatory_multi_field || false;
          } else if (value !== '' && levelThreeValues?.length > 0) {
            levelThreeValues = levelTwoValues[0].level_1;
            if (levelThreeValues?.length === 0) {
              finalError = false;
            } else {
              finalError = field?.mandatory_multi_field || false;
            }
          }
        }
      } else if (key === 'level_3') {
        let levelZeroValues = specificFieldValues.filter(
          val => (val?.name === ans_values?.level_0)
        );
        let levelOneValues = [];
        let levelTwoValues = [];
        let levelThreeValues = [];
        if (levelZeroValues.length > 0) {
          levelOneValues = levelZeroValues[0].location_levels;
        }
        if (ans_values?.level_0 && ans_values?.level_1 && ans_values?.level_2 && levelOneValues?.length > 0) {
          levelTwoValues = levelOneValues.filter(
            val => (val?.title === ans_values?.level_1)
          );
          levelTwoValues = levelTwoValues[0].level_1;
          levelTwoValues = levelTwoValues.filter(
            val => (val?.title === ans_values?.level_2)
          );
          levelThreeValues = levelTwoValues[0].level_2;
          if (levelThreeValues.length === 0) {
            finalError = false;
          } else if (value !== '' && levelThreeValues?.length > 0) {
            finalError = false;
          }
        }
      }
    }
    return finalError;
  }

  handleMultiFieldIndividualError = () => {
    const {
      answers: {
        form_date,
        created_by,
        source,
        name,
        email,
        phone,
        ...form_data
      }
    } = this.state;
    const { form: { form: { schema: { fields } } } } = this.props;
    let finalErrorData = [];
    fields.forEach((field) => {
      if (field.type === 'multi_field' && field.multiple_fields && !field.repeat_field) {
        const formValues = form_data[field.id]?.[0] || {};
        if (!formValues) return;
        finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(
          field, formValues, this.handleSectionErrorMultiLevelField, this.handleMultiColumnGLS,
          form_data
        )];
      } else if (field.type === 'multi_field' && field.multiple_fields && field.repeat_field) {
        const formValues = form_data[field.id];
        if (!formValues) {
          finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(
            field, {}, this.handleSectionErrorMultiLevelField, this.handleMultiColumnGLS,
            form_data
          )];
        } else {
          formValues.forEach((formValue) => {
            finalErrorData = [...finalErrorData, ...handleMultiGridSpecificFieldError(
              field, formValue, this.handleSectionErrorMultiLevelField, this.handleMultiColumnGLS,
              form_data
            )];
          });
        }
      }
    });
    return finalErrorData;
  }

  handleValidErrors = (errorMCGlist, errorsList, fieldErrors, fieldTitles, customMessage, customErrors, fieldErrorsData) => {
    let fieldErrorsList = [];
    const multiValidReqFields = errorMCGlist?.flatMap(err => Object.keys(err)?.map(e => e));
    const customReqFields = Object.keys(errorsList || {})?.filter(err => errorsList[err] !== '');
    const reqFields = [...Object.keys(fieldErrorsData || {})?.filter(t => fieldErrorsData[t] === true),
    ...multiValidReqFields, ...customReqFields];
    const uniqueReqFields = new Set(reqFields);
    fieldErrorsList = Array.from(uniqueReqFields)?.map(req => fieldTitles[req]);
    fieldErrorsList = fieldErrorsList.filter(item => item !== undefined);
    let multiFieldError = this.handleMultiFieldIndividualError();
    if (multiFieldError.length === 0) {
      const { form: { form: { schema: { fields } } } } = this.props;
      const newFieldErrors = { ...fieldErrors };
      fields.forEach((field) => {
        if (field.type === 'multi_field') {
            newFieldErrors[field.id] = false;
        }
      });
      this.setState({ fieldErrors: newFieldErrors });
    }
    fieldErrorsList = [...fieldErrorsList, ...multiFieldError];
    this.setState({ showFormErrors: true, customMessage, customErrors, errorModal: true, fieldErrorsList, fieldErrors: fieldErrorsData });
    return fieldErrorsList?.length > 0;
  }

  handleSubmit = async (isDraft) => {
    const {
      answers: { form_date, created_by, ...form_data },
      signatureFields
    } = this.state;
    const {
      form: { form: { schema: { fields } } },
      location,
      form,
      actionCreateAnswer,
      user
    } = this.props;
    let { fieldErrors } = this.state;
    this.setState({ loadingStatus: true, warningModal: false });
          fields.forEach((val) => {
            if (val?.type === 'datetime' && !val.required) {
            fieldErrors = { ...fieldErrors, [val.id]: false };
          }
          if (val?.type === 'toggle') {
            fieldErrors = { ...fieldErrors, [val.id]: false };
          }
      });
    let fieldErrorsData = { ...fieldErrors };
    let noErrors = isDraft || fieldErrorsData && Object.keys(fieldErrorsData).every(
      k => fieldErrorsData[k] === false
    );
    const attachmentFields = form?.form?.schema?.fields.filter(schemaField => (
      schemaField?.type === 'attachments' || schemaField?.type === 'multi_field'
    ));
    const defaultFormSubmitFields = form?.form?.schema?.fields.filter(field => (
      (['date', 'datetime', 'dateWithSeconds', 'datetimeWithSeconds'].includes(field.type))
      && field?.default_form_submit_date
    ));
    const dateFields = fields?.filter(item => (
      ['date', 'datetime', 'dateWithSeconds', 'datetimeWithSeconds'].includes(item?.type)
    ));
    if (dateFields?.length > 0) {
      for (let index = 0; index < dateFields.length; index++) {
        const dateField = dateFields[index]?.id;
        const schemaField = dateFields[index];
        if (form_data[dateField] !== undefined && form_data[dateField] !== null && form_data[dateField] !== '') {
          form_data[dateField] = normalizeSubmittedDateValue(schemaField, form_data[dateField]);
        }
      }
    }
      if (defaultFormSubmitFields.length > 0) {
        for (let index = 0; index < defaultFormSubmitFields.length; index++) {
          const dateField = defaultFormSubmitFields[index]?.id;
          form_data[dateField] = moment().format();
        }
      }
      if (attachmentFields.length > 0) {
        for (let index = 0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments' && form_data[attachmentField]?.length > 0) {
            form_data[attachmentField] = form_data[attachmentField]
            .map(item => item?.attachment_id)
            .filter(aid => typeof aid === 'string');
          } else if (schemaField?.type === 'multi_field') {
            const multiAttachmentFields = schemaField?.multiple_fields
              && Object.keys(schemaField?.multiple_fields)?.filter(f => schemaField?.multiple_fields?.[f]?.type?.key === 'attachments');
            if (multiAttachmentFields?.length > 0) {
              for (let multiIndex = 0; multiIndex < multiAttachmentFields?.length; multiIndex++) {
                for (let multiDataIndex = 0; multiDataIndex < form_data?.[schemaField?.id]?.length; multiDataIndex++) {
                  const attachments = form_data?.[schemaField?.id]?.[multiDataIndex]?.[multiAttachmentFields[multiIndex]] || [];
                  if (attachments?.length > 0) {
                    form_data[schemaField?.id][multiDataIndex][multiAttachmentFields[multiIndex]] = attachments?.map(attach => (
                      attach?.attachmentUploadId || attach?.name
                    ));
                  }
                }
              }
            }
          }
        }
      }
      const tagData = [];
      Object.keys(form_data).forEach((k) => {
        if (k === 'tags' && form_data[k] !== null && form_data[k] !== undefined) {
          form_data[k].forEach(tag => tagData.push(tag.name));
          form_data.tags = tagData;
        }
      });
      if (signatureFields.length > 0) {
        for (let i = 0; i < signatureFields.length; i++) {
          const signatureField = signatureFields[i];
          if (form_data[signatureField]) {
            form_data[signatureField] = await this.handleUploadAttachments([form_data[signatureField]], 'form_signature');
          }
        }
      }

      fields.forEach((val) => {
        const phoneType = val?.type === 'string' && val?.validators?.length > 0 && val?.validators[0]?.label === 'Phone Number' && val;
        if (phoneType && form_data[phoneType.id]) form_data[phoneType.id] = form_data[phoneType.id][0] + form_data[phoneType.id].slice(1).replace(/[^\d]/g, '');
        if (val?.type==='dataSourceMultiLevel'&& val?.dataSourceID === 'ds2' && form_data[val?.id]?.selected_map ==='indoor') {
          delete form_data[val?.id].map_location;
        }
      });

      const task_details = location?.state?.taskid ? location.state : {};
      const data = {
        form_date: new Date(form_date),
        created_by,
        data: form_data,
        has_map_location: getHasMapLocation(fields, form_data),
        tags: form_data.tags,
        email_date: moment().format(),
        email_form_date: moment().format('MM-DD-YYYYTHH:mm A'),
        task_details,
        portal_tenant: user?.current_tenant?.name
      };
      if (isDraft) {
        data.status = 'draft';
      }
      if (fields?.length > 0) {
        fields.forEach((field) => {
          if (field.type === 'toggle' && !Object.prototype.hasOwnProperty.call(data.data, field.id)) {
              data.data[field.id]=false;
          }
          if (field.type === 'risk_assess' && field?.required) {
            data.data[field.id]={};
          }
        });
      }
      if (noErrors) {
        actionCreateAnswer(form.id, data);
      } else {
        this.setState({ loadingStatus: false, showFormErrors: true });
      }
  };

  doS3Upload = async (files, fileIds, entity, getErrorAlert) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      undefined,
      undefined,
      getErrorAlert
    );
    return response;
  };

  handleTabClick = (index) => {
    const { groupedSections } = this.state;
    if (groupedSections?.length > 0) {
      const { items } = groupedSections[index];
      this.setState({
        formActiveIndex: index,
        formTabFeilds: items,
        loadingStatus: false
      });
    }
  }


  showTabSection = (groupedSections, formActiveIndex) => {
    const { showFormErrors } = this.state;
    return (
      <div className={`${styles.navigation} ${styles.sectionTabsSty}`}>
        {groupedSections?.map((field, index) => (
            <Clickable
            // eslint-disable-next-line no-nested-ternary
              className={showFormErrors
              // eslint-disable-next-line no-nested-ternary
                ? field?.fieldErrors
                  ? styles.fieldErros : index === formActiveIndex
                    ? styles.active:''
                :index === formActiveIndex ? styles.active:''}
              onClick={() => this.handleTabClick(index)}
            >
              <span>{field.header}</span>
            </Clickable>))}
      </div>
    );
  };

  handleAnotherEntry = () => {
    window.location.reload();
  }

  updateTags = (allTags, tags) => {
    let updatedData = [];
    if (allTags && tags?.length===0) {
      updatedData = allTags?.map(e => ({ id: e?.name, name: e?.name }));
    } else {
      updatedData = allTags?.filter(value => tags?.find(i => i?.name === value?.name)?.name !== value?.name);
    }
    this.setState({ opsLogTags: updatedData });
  };

  handleRemoveTag = (tag) => {
    const { answers } = this.state;
    const updatedOpsLogTags = answers?.tags?.filter(e => e?.id!==tag?.id);
    this.setState(prev => ({ opsLogTags: [...prev?.opsLogTags, tag], answers: { ...answers, tags: updatedOpsLogTags } }));
  };

  indexOfSectionHeader = (sections, id) => sections.findIndex(val => val.items.some(e => e.id === id));

  setAlert = (value) => {
    this.setState({ alert: value });
  }

  toastAlert = () => {
    toast.error('Attachment upload failed. Please try again.');
    this.setAlert(false);
  }

  render() {
    const { form, history, globalLocationList, createdFormAnswer, user, dataSourceValues } = this.props;
    const {
      showFormErrors,
      requiredMap,
      answers,
      loadingStatus,
      errorsList,
      placeHolders,
      formActiveIndex,
      groupedSections,
      formTabFeilds,
      fieldErrors,
      customMessage,
      apiStatus,
      apiStatusError,
      opsLogTags,
      errorListMCG,
      fieldErrorsList,
      errorModal,
      warningErrors,
      warningModal,
      alert
    } = this.state;
    const title = form ? form.title : 'New Form';
    const icon = form ? form.icon : 'icon-2.png';
    const sectionHeaders = formTabFeilds?.filter(field => field.type === 'header');

    const getCustomFieldComponent = fields => (
      <CustomFields
          handleAnswerChanged={(a, b, c, d, e) => this.handleAnswerChanged(a, b, c, d, e)}
          handleFieldErrorChanged={this.handleFieldErrorChanged}
          showFormErrors={showFormErrors}
          fieldErrors={fieldErrors}
          formTabFeilds={formTabFeilds}
          requiredMap={requiredMap}
          errorsList={errorsList}
          placeHolders={placeHolders}
          accessibleTenants={form?.tenants}
          fields={fields}
          formEntryFields={form?.form?.schema?.fields || []}
          answers={answers}
          handleUploadAttachments={this.handleUploadAttachments}
          myforms
          fromForms
          globalLocationList={globalLocationList}
          defaultLocation={user.portal_airport.location.coordinates}
          handleCheckListAnswer={this.handleCheckListAnswer}
          dateEditable
          errorListMCG={errorListMCG}
          dataSourceValues={dataSourceValues}
          handleAttachmentFailedAlert={this.getErrorAlert}
          handleAutoUploadAttachments={this.uploadtoS3}
          entityName="myForms"
        />
    );
    return (
      <>
        <Loading loadingStatus={loadingStatus} />
        <SectionHeader
          icon={this.images[icon]?.default}
          translationID="invalid"
          defaultTitle={title}
        />
        <HeaderBack
          translationID="form.start.back"
          translationDefault="Back to Forms"
          backRoute={this.URL}
          myForms
        >
          { apiStatus ? '' : this.showTabSection(groupedSections, formActiveIndex)}
        </HeaderBack>
        {(!apiStatus && !apiStatusError) && (
        <div className={styles.container}>
          <div className={styles.details}>
            <p className={`${styles.instructions} ${styles.break_text}`}>{form?.additionalInfo}</p>
            {requiredMap && sectionHeaders?.length > 0 && formTabFeilds?.length > 0
              && sectionHeaders?.length > 0
              && <CollapsibleSections
                  fieldsList={formTabFeilds}
                  getCustomFieldComponent={getCustomFieldComponent}
                  answers={answers} />}
            {requiredMap
              && formTabFeilds?.length > 0 && !sectionHeaders?.length && (
                getCustomFieldComponent(formTabFeilds)
            )}
            {form?.settings?.enable_tags
                  && (
                  <div style={{ marginLeft: '43px' }}>
                    <TagComponent handleTagSelect={this.handleAnswerChanged} opsLogTags={opsLogTags}
                      handleTagSelectProps={['tags']} module="forms" handleRemoveTag={this.handleRemoveTag}
                      updatedOpslogTags={answers?.tags} updatedOpsOldTags={answers?.oldTags}
                    />
                  </div>
                )}
            <div className={styles.footer} style={{ marginTop: '45px' }}>
              {customMessage
                  && (
                    <p style={{ color: 'red', marginLeft: '-20px' }}>{customMessage}</p>
                )}
              <Button action={formActiveIndex === 0 ? 'tertiary' : 'secondary'}
                onClick={formActiveIndex === 0 ? this.goBackToForms : () => this.handleTabClick(formActiveIndex - 1)}
                translationID={formActiveIndex === 0 ? 'inspections.new.cancelBtn' : 'inspections.new.prev'}
                defaultText={formActiveIndex === 0 ? 'Cancel' : 'Back'}
              />

                  {groupedSections?.length === formActiveIndex
                   && <div className={styles.completeBtn}>
                          <Button
                            action="tertiary"
                            onClick={() => (form?.settings?.enable_ShitTask_when_the_status_is_draft
                            ? this.setState({ showModal: true }): this.handleValidations(true))}
                            translationID="inspections.complete_inspections.save_as_draft"
                            defaultText="Save as Draft"
                          />
                      </div>}
              {form?.id && (
                <Button
                  action="secondary"
                  onClick={() => {
                    if (groupedSections.length > 0 && groupedSections.length !== formActiveIndex + 1) {
                      this.handleTabClick(formActiveIndex + 1);
                    } else {
                      this.handleValidations(false);
                    }
                  }}
                  translationID={groupedSections?.length > 0 && groupedSections?.length !== formActiveIndex + 1
                    ? 'inspections.new.next' : 'form.submit_form'}
                  defaultText="Submit Form"
                />
              )}
            </div>
          </div>
        </div>
        )}
        <Modal
          showIn={warningModal}
          onClose={() => this.setState({ warningModal: false })}
          contentStyles={{
            width: '25%',
            minHeight: '20%'
          }}
        >
          <div className={styles.linkModalHeader}>
            <FormattedMessage
              id="inspection.link.to_form"
              defaultMessage="Warning"
            />
            <Clickable
              onClick={() => this.setState({ warningModal: false })}
              className={styles.closeIcon}
            >
              <img src={closeIcon} alt="X" />
            </Clickable>
          </div>
          <div className="container" style={{ margin: '20px', overflowY: 'auto', maxHeight: '200px' }}>
            {Array.isArray(warningErrors) && warningErrors.map(error => (
              <div style={{ position: 'absolute', marginBottom: '12rem' }}>
                <p style={{ color: 'red', textAlign: 'center' }}>
                  {error}
                </p>
              </div>
            ))}
          </div>
          <div className={styles.confirmFooter}>
            <Button action="tertiary"
              onClick={() => this.setState({ warningModal: false })}
              translationID="inspections.new.cancelBtn"
              defaultText="Cancel"
            />
            <Button
              action="secondary"
              onClick={this.handleSubmit}
              translationID="forms.edit.create_anyway"
              defaultText="Create Anyway"
            />
          </div>
        </Modal>
        {/* error display modal */}
        {fieldErrorsList?.length > 0 && (
        <Modal
          showIn={errorModal}
          onClose={() => this.setState({ errorModal: false })}
          contentStyles={{
            width: '554px',
            minHeight: '20%'
          }}
        >
        <div className={styles.contentErrorModal}>
          <div className={`${styles.linkModalHeader} ${styles.header}`}>
            <FormattedMessage
              id="inspection.link.to_form"
              defaultMessage="Missing Required Information"
            />
            <Clickable
              onClick={() => this.setState({ errorModal: false })}
              className={styles.closeIcon}
            >
              <img src={closeIcon} alt="X" />
            </Clickable>
          </div>
          <div className={`container ${styles.content}`}>
            <ul style={{ color: 'red', textAlign: 'left' }}>
              {fieldErrorsList && fieldErrorsList.map(error => (
                <li style={{ margin: '10px 0px' }}>{error}</li>
              ))}
            </ul>
          </div>
          <div className={styles.errorFooter}>
            <Button action="tertiary"
              onClick={() => this.setState({ errorModal: false })}
              translationID="inspections.new.cancelBtn"
              defaultText="Cancel"
            />
          </div>
        </div>
        </Modal>
        )
      }
        {(apiStatus || apiStatusError) && (
        <div className={styles.container}>
          <FormSubmitted
            name={title}
            message={createdFormAnswer?.status === 'draft'?'Your Form Successfully Saved':'Your Form was successfully submitted'}
            logo={this.images[icon]}
            isForm
            isDraft={createdFormAnswer?.status === 'draft'}
            handleGoForms={() => history.push(`${MYFORMS}/`)}
            handleEntry={() => this.handleAnotherEntry()}
          />
        </div>
        )}
        {alert && this.toastAlert()}
      </>
    );
  }
}

CompleteForm.propTypes = {
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired,
  // actionClear: PropTypes.func.isRequired,
  actionCreateAnswer: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  form: state.forms.publishedFormData,
  user: state.auth?.profile,
  dataSourceValues: state.inspection.dataSourceValues,
  dataSourceAction: state.inspection.action,
  createAction: state.forms?.createFormAnswerAction,
  opslog_tags: state.forms?.getFormsSchema?.opslog_tags,
  Tags: state.forms?.getFormsSchema?.tags,
  getFormSchemaAction: state.forms?.getPublishedFormAction,
  globalLocationList: state.forms?.getFormsSchema?.locations,
  createdFormAnswer: state.forms?.formAnswerDetails
});

const mapDispatchToProps = dispatch => ({
  actionFetch: (id) => {
    dispatch(fetchPublishedForm(id));
  },
  actionCreateAnswer: (id, data) => {
    dispatch(createFormAnswer(id, data));
  },
  actionFetchFormSchema: (data) => {
    dispatch(getPortalFormSchema(data));
  },
  acitonGetTabView: () => {
    dispatch(actionSaveTabView('forms'));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CompleteForm));
